import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import routes from "../../routes";
import { UploadLimitComponent } from "../../containers/UploadDocuments/components/UploadLimit/UploadLimit";
import { StyleApplicationStatus } from "./styled";

//ro-assist-brd2-3
const accountComparisionRoute = {
  link: routes.quickapplyLanding,
  label: "See products"
};
export const ApplicationStatus = ({
  icon,
  text,
  link,
  screeningType = "",
  buttons = [accountComparisionRoute]
}) => {
  const navigate = useNavigate();
  const redirectTo = (route, external) => {
    if (external) {
      window.location.href = route;
    } else {
      navigate(route);
      window.location.reload();
    }
  };
  return (
    <>
      {screeningType === "Total No of Documents uploaded check" ? (
        <UploadLimitComponent />
      ) : (
        <StyleApplicationStatus>
          <img src={icon} alt="error" />
          <div className={"message"}>
            <p>{text}</p>
            {/* ro-assist-brd2-3 */}
            {link && (
              <div className={"linkWrapper"}>
                {buttons.map((btn, index) => (
                  <Button
                    key={index}
                    onClick={() => redirectTo(btn.link, btn.external)}
                    className={"appStatusLink"}
                  >
                    {btn.label}
                  </Button>
                ))}
              </div>
            )}
          </div>
        </StyleApplicationStatus>
      )}
    </>
  );
};
